import React from 'react';
import { graphql } from 'gatsby';
import { Image as ImageComponent } from '../../Image';
import { Section } from '../../Section';

export const Img = ({ data, ...rest }) => (
  <Section contained narrow {...rest}>
    <ImageComponent {...data} />
  </Section>
);

export const ImageQuery = graphql`
  fragment Image on KFH_UmbracoImageComponentType {
    caption
    image {
      altText
      localFile {
        gatsbyImage(width: 736, layout: FULL_WIDTH, placeholder: NONE, quality: 80, backgroundColor: "#F5F5F5")
      }
    }
  }
`;
